import classes from './loadingIndicator.scss';

export default class LoadIndicator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activityCounter: this.props.activityCounter
        };
        this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/loadinganimation.gif';

    }
    // loadingIndicator = () => {
    //     this.setState({ showLoading: true, activityCounter: activityCounter + 1 });
    // }

    render() {
        return (
            <div>
                {(this.props.showLoading || this.state.activityCounter > 0) ?
                    <div>
                        <div className={classes.loadingPosition}>
                            <img className={classes.outerImage} src={this.imageInfo} />
                        </div>
                    </div> : null
                }
            </div>
        );
    }
}
